export enum Store {
  MAIN_STORE = "t1111111-1111-1111-1111-111111111111",
}

export const StoreInfo = {
  [Store.MAIN_STORE]: { name: "Main Store", isMainStore: true },
} as const;

export const getStoreName = (value: Store): string => StoreInfo[value].name;
export const isMainStore = (value: Store): boolean =>
  StoreInfo[value].isMainStore;
